import { hasPackagedPicks } from 'utils/system-composition';
import { CompositionPicks } from 'utils/system-composition-types';

export function compositionHasEquipmentType(
  picks: CompositionPicks | null | undefined
): boolean {
  if (!picks) return false;
  return (
    picks.outdoor !== null ||
    picks.blower !== null ||
    picks.coil !== null ||
    hasPackagedPicks(picks)
  );
}

export function compositionHasFuel(
  picks: CompositionPicks | null | undefined
): boolean {
  return picks?.blowerFuel != null || picks?.packagedFuel != null;
}

export function compositionWantsPackagedUnit(
  picks: CompositionPicks | null | undefined
): boolean {
  return !!picks && hasPackagedPicks(picks);
}

export function compositionPicksAreEqual(
  left: CompositionPicks | null | undefined,
  right: CompositionPicks | null | undefined
): boolean {
  if (left === right) return true;
  if (!left || !right) return false;
  return (
    left.outdoor === right.outdoor &&
    left.blower === right.blower &&
    left.blowerFuel === right.blowerFuel &&
    left.coil === right.coil &&
    left.packagedCooling === right.packagedCooling &&
    left.packagedHeating === right.packagedHeating &&
    left.packagedFuel === right.packagedFuel
  );
}
